import React, { useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const SectionAccordionTitle = ({ children }) => {
  return <AccordionSummary expandIcon={<ExpandMoreIcon />}>{children}</AccordionSummary>;
};

export const SectionAccordionContent = ({ children }) => {
  return <AccordionDetails>{children}</AccordionDetails>;
};

export const SectionAccordion = ({ children, isExpanded = false }) => {
  const [expanded, setExpanded] = useState(isExpanded);

  const handleChange = () => {
    setExpanded((expanded) => !expanded);
  };

  return (
    <Accordion expanded={expanded} onChange={handleChange}>
      {children}
    </Accordion>
  );
};
